import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { StatusBanner } from "@/components/StatusBanner";

export function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <StatusBanner />
      <main className="flex-1">{children}</main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export function SectionTitle({ label, title, subtitle, center }) {
  return (
    <div className={`mb-10 ${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}`}>
      {label && <div className="text-xs font-semibold uppercase tracking-widest text-amber-400 mb-3">{label}</div>}
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight">{title}</h2>
      {subtitle && <p className="text-gray-400 mt-3 text-base leading-relaxed">{subtitle}</p>}
    </div>
  );
}
